var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bg",staticClass:"unsplash-backgroud",class:_vm.imgClass,style:(_vm.style),on:{"dblclick":_vm.changeBackgroundImage,"contextmenu":_vm.clear}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }